import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ZoomReaderForm from '../forms/zoom-reader-form';
import { zoomReaderValidationSchema } from '../schema/zoomReader.js';

export default function ZoomReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Zoom Reader Node Details',
        altText: 'Zoom Reader Node',
        defaultLabel: 'Zoom Reader Node',
      }}
    >
      <CommonNode FormComponent={ZoomReaderForm} schemaResolver={zoomReaderValidationSchema} />
    </NodeProvider>
  );
}
